export const HOURS_TO_EXPIRE = 1 // number of hours to consider a document expired.
